export const margin = {
  left: 5,
  right: 5,
  top: 5,
  bottom: 5
} as const;

export const colors = {
  primary: "#4D4D4D",
  secondary: "#78787A",
  accent: "#B82025",
  border: "#E0E0E0",
  lightGray: "#A7A8AA",
  white: "#FFFFFF",
  tableHeader: "#F5F6F7"
} as const;
